import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import bcrypt from "bcryptjs";
import { ALL_USERS, CREATE_USER } from "../queries";

import { useParams } from "react-router-dom";
import { TextField, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
import MKBox from "components/MKBox";
//import {useTranslation} from "react-i18next"
/*
import {useTranslation} from "react-i18next"
const [t, i18n] = useTranslation("common")
{t("headers.agendas")}

*/
import ReCAPTCHA from "react-google-recaptcha";
/* eslint-disable react/prop-types */
const UserForm = ({ setError }) => {
  // eslint-disable-next-line;
  //const [t, i18n] = useTranslation("common");
  const [t] = useTranslation("common");
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [postnumber, setPostnumber] = useState("");
  const [postoffice, setPostoffice] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [repassword, setRepassword] = useState("");
  const [activated, setActivated] = useState(false);
  const [datetime, setDatetime] = useState("");
  const [type, setType] = useState("");
  const [role, setRole] = useState("");
  const [gender, setGender] = useState("");
  const [born, setBorn] = useState("");
  const [municipality, setMunicipality] = useState("");
  const [secondarymunicipality, setSecondarymunicipality] = useState("");
  const [country, setCountry] = useState("");
  // eslint-disable-next-line
  const [token, setTokeni] = useState("");
  //console.log(token);
  const [verified, setVerified] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  // eslint-disable-next-line
  const [executing, setExecuting] = useState(false);
  //console.log(setExecuting);
  // eslint-disable-next-line
  const [acceptedtermsofuse, setAccepted] = useState(
    "Sat Feb 27 2021 09:21:48 GMT+0200 (Itä-Euroopan normaaliaika)"
  );
  //console.log(setAccepted);
  // eslint-disable-next-line
  const [code, setCode] = useState("ddSDSFr434");
  //console.log(setCode);
  function onChange(value) {
    //console.log("Captcha value:", value);
    setTokeni(value);
    setVerified(!verified);
  }
  const [createUser] = useMutation(CREATE_USER, {
    refetchQueries: [{ query: ALL_USERS }],
    // eslint-disable-next-line
    onError: (error) => {
      //setError(error.graphQLErrors[0].message);
      //console.log(error);
      setError("virhe");
    },
    /*update: (store, response) => {;
      updateCacheWith(response.data.addComment);
    }*/
  });
  // eslint-disable-next-line;
  let userss = "";
  // eslint-disable-next-line
  userss = useParams().id;
  //console.log(userss);
  const uusi = async (event) => {
    //console.log(event);
    const aika = Date.now();
    const pvm = new Date(aika);
    setDatetime(pvm.toString());
    setName(event);
    //setUser(sectionss);
  };

  const submit = async (event) => {
    event.preventDefault();
    if (password === repassword) {
      //const saltRounds = 17;
      var salt = bcrypt.genSaltSync(12);
      const passwordhash = await bcrypt.hash(password, salt);
      //console.log(passwordhash);
      /* const user = new User({;
        username: body.username,;
        name: body.name,;
        passwordHash,;
      });
    ;
      const savedUser = await user.save();
    ;
      response.json(savedUser);
      */
      //const passwordhash = password;
      createUser({
        variables: {
          name,
          email,
          passwordhash,
          address,
          postnumber,
          postoffice,
          datetime,
          phone,
          activated: false,
          type,
          role,
          municipality,
          secondarymunicipality,
          acceptedtermsofuse,
          code,
        },
      });
      //sectionid: sectionid.length > 0 ? sectionid : "tyhjä";
      setDatetime("");
      setName("");
      setEmail("");
      setPassword("");
      setAddress("");
      setPostnumber("");
      setPostoffice("");
      setPhone("");
      setRepassword("");
      setType("");
      setRole("");
      setActivated("");
      setBorn("");
      setGender("");
      setMunicipality("");
      setSecondarymunicipality("");
      setCountry("");
      setSubmitted(true);
      //setSectionid(sectionss);
    } else {
      alert("Salasanat eivät täsmää");
    }
  };
  /*onst stylea = {
    background: "white",
    opacity: 0.9
  };*/
  //useEffect(() => {;
  // setSectionid(sectionss);
  //}, []);
  if (submitted) {
    return (
      <div>
        <h2>{t("headers.addcommentorinformation")}</h2>
        {t("common.formok")}
        <br />
      </div>
    );
  } else {
    return (
      <MKBox pt={6} px={1} mt={6}>
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
            <MKTypography
              variant="body1"
              color="dark"
              textAlign="center"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              <h2>{t("headers.adduser")}</h2>
              <form onSubmit={submit}>
                {t("common.name")}
                <TextField value={name} onChange={({ target }) => uusi(target.value)} />
                <br />
                <br />
                {t("common.email")}
                <TextField value={email} onChange={({ target }) => setEmail(target.value)} />
                <br />
                <br />
                {t("common.password")}
                <TextField
                  type="password"
                  value={password}
                  onChange={({ target }) => setPassword(target.value)}
                />
                <br />
                <br />
                {t("common.repassword")}
                <TextField
                  type="password"
                  value={repassword}
                  onChange={({ target }) => setRepassword(target.value)}
                />
                <br />
                <br />
                {t("common.address")}
                <TextField value={address} onChange={({ target }) => setAddress(target.value)} />
                <br />
                <br />
                {t("common.postnumber")}
                <TextField
                  value={postnumber}
                  onChange={({ target }) => setPostnumber(target.value)}
                />
                <br />
                <br />
                {t("common.postoffice")}
                <TextField
                  value={postoffice}
                  onChange={({ target }) => setPostoffice(target.value)}
                />
                <br />
                <br />
                {t("common.born")}
                <TextField value={born} onChange={({ target }) => setBorn(target.value)} />
                <br />
                <br />
                {t("common.gender")}
                <TextField value={gender} onChange={({ target }) => setGender(target.value)} />
                <br />
                <br />
                {t("common.municipality")}
                <TextField
                  value={municipality}
                  onChange={({ target }) => setMunicipality(target.value)}
                />
                <br />
                <br />
                {t("common.secondarymunicipality")}
                <TextField
                  value={municipality}
                  onChange={({ target }) => setSecondarymunicipality(target.value)}
                />
                <br />
                <br />
                {t("common.country")}
                <TextField value={country} onChange={({ target }) => setCountry(target.value)} />
                <br />
                <br />
                {t("common.phone")}
                <TextField value={phone} onChange={({ target }) => setPhone(target.value)} />
                <br />
                <br />
                {t("common.active")}
                <TextField
                  value={activated}
                  onChange={({ target }) => setActivated(target.value)}
                />
                <br />
                <br />
                {t("common.usertype")}
                <TextField value={type} onChange={({ target }) => setType(target.value)} />
                <br />
                <br />
                {t("common.role")}
                <TextField value={type} onChange={({ target }) => setRole(target.value)} />
                <br />
                <br />
                <div>
                  <ReCAPTCHA
                    sitekey="6Lf6wLIaAAAAAORH1jwBkpv1NzwvaBYa9mpn39GP"
                    onChange={onChange}
                  />
                </div>
                <br />
                <br />
                <Button
                  style={{
                    backgroundColor: "#07575B",
                    color: "#C4DFE6",
                    fontSize: "14px",
                  }}
                  type="submit"
                  disabled={!verified}
                  executing={executing}
                  submitted={submitted}
                >
                  {submitted ? t("common.done") : executing ? "Verifying" : t("common.send")}
                </Button>
                <br />
                <br />
              </form>
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
    );
  }
};

export default UserForm;
